import * as zod from 'zod';

export default zod.object({
  completedCount: zod.number().int().nonnegative(),
  currentActivity: zod.enum([
    'none',
    'requestingPlan',
    'planning',
    'receivingPlan',
    'moving',
    'paused',
  ]),
  /**
   * The current linear distance moved from the starting pose (in meters).
   * Continuously updated during motion execution.
   */
  distanceMovedToNextWaypoint: zod.number().nonnegative().default(0),
});
